import { render } from "./Offer.vue?vue&type=template&id=7fd9847a"
import script from "./Offer.vue?vue&type=script&lang=ts"
export * from "./Offer.vue?vue&type=script&lang=ts"
script.render = render

export default script